class MegaMenu extends HTMLElement {
  /** @type {NodeListOf<HTMLElement>} */ #controllers = this.querySelectorAll('[aria-controls]');

  connectedCallback() {
    this.#controllers.forEach((controller) => {
      // Always keep 1 item open, so no mouseLeave for closing
      controller.addEventListener('mouseenter', () => this.#handleMouseenter(controller));
      controller.addEventListener('focus', () => this.#handleMouseenter(controller));
    });
  }

  /**
   * Handle controller mouseenter
   * @param {HTMLElement} controller
   */
  #handleMouseenter(controller) {
    this.#open(controller, controller.ariaControlsElements[0]);
  }

  /**
   * Open the active item
   * @param {HTMLElement} controller
   * @param {HTMLElement} target
   */
  #open(controller, target) {
    controller.ariaExpanded = 'true';
    target.ariaHidden = 'false';
    this.#closeOtherItems(controller);
  }

  /**
   * Close any non-active items
   * @param {HTMLElement} controller
   */
  #closeOtherItems(controller) {
    this.#controllers.forEach((item) => {
      if (item === controller) return;
      item.ariaExpanded = 'false';
      item.ariaControlsElements[0].ariaHidden = 'true';
    });
  }
}

customElements.define('mega-menu', MegaMenu);
